import { render } from "./NavigationPhoneMenuItemWithCircles.vue?vue&type=template&id=2cd02444"
import script from "./NavigationPhoneMenuItemWithCircles.vue?vue&type=script&lang=js"
export * from "./NavigationPhoneMenuItemWithCircles.vue?vue&type=script&lang=js"

import "./NavigationPhoneMenuItemWithCircles.vue?vue&type=style&index=0&id=2cd02444&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__